module.exports = __webpack_public_path__ + "static/media/windows-logo.67767cf2.svg";